import React from "react";
import ProductList from "./ProductList";
import useUpdateProducts from "../../hooks/useUpdateProducts";

const ProductsList = ({ locationState, customHTML, setCaliber }) => {
  const { currentPage, allPages, productsInfo, productsLoadingStatus } =
    useUpdateProducts(locationState);


  return (
    <ProductList
      currentPage={currentPage}
      allPages={allPages}
      productsInfo={productsInfo}
      productsLoadingStatus={productsLoadingStatus}
      locationState={locationState}
      customHTML={customHTML}
      setCaliber={setCaliber}
    />
  );
};

export default ProductsList;
